/**
 * Waits for a condition to become true within a timeout.
 * @param checkCondition - A function that returns a boolean indicating whether the condition is met.
 * @param timeout - The maximum time to wait (in milliseconds).
 * @param interval - The interval to check the condition (in milliseconds, default is 50ms).
 * @returns A promise that resolves when the condition is true or rejects on timeout.
 */
const waitForReady = (
  checkCondition: () => boolean,
  timeout: number,
  interval = 100
) => {
  const startTime = Date.now();
  let timeoutId: NodeJS.Timeout;

  const wait = new Promise<void>((resolve, reject) => {
    const check = () => {
      try {
        if (checkCondition()) {
          resolve();
        } else if (Date.now() - startTime >= timeout) {
          reject(new Error('Timeout waiting for condition to be true'));
        } else {
          timeoutId = setTimeout(check, interval);
        }
      } catch (error) {
        reject(error);
      }
    };
    check();
  });

  const cleanup = () => {
    if (timeoutId) clearTimeout(timeoutId);
  };

  return { wait, cleanup };
};

export default waitForReady;
